export default "__VITE_ASSET__CxFYjVOU__"